module.exports = __webpack_public_path__ + "static/logos_landing_ad-3528f09b5666b18011897a5877404631.png";